import * as React from 'react';
import { useSelector } from 'react-redux';
import { Responsive } from '@cian/ui-kit';

import { LocationModalContainerDesktop } from './desktop';
import { LocationModalContainerMobile } from './mobile';
import { selectIsRedesign } from '../../../selectors/isRedesign';

export const LocationModalContainer: React.FC = () => {
  const isRedesign = useSelector(selectIsRedesign);

  if (!isRedesign) {
    return null;
  }

  return (
    <>
      <Responsive desktop>
        <LocationModalContainerDesktop />
      </Responsive>
      <Responsive tablet phone>
        <LocationModalContainerMobile />
      </Responsive>
    </>
  );
};
